import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { Adfox } from '../Adfox';
import * as styles from './CountryBuildingsBanners.css';
import { UIHeading1 } from '@cian/ui-kit';
import { Container } from '../Container';

const bannersCount = 4;

interface ICountryBuildingsBannersProps {
  visible?: boolean;
  onLoad?: () => void;
  onBannerClick?: () => void;
}

export const CountryBuildingsBanners: React.FC<ICountryBuildingsBannersProps> = ({
  visible,
  onLoad,
  onBannerClick,
}) => {
  return (
    <Container {...mergeStyles(!visible && styles['hidden'])}>
      {visible && (
        <div className={styles['heading']}>
          <UIHeading1>Проекты домов от строительных компаний</UIHeading1>
        </div>
      )}
      <div className={styles['banners-container']}>
        {new Array(bannersCount).fill(null).map((_, index) => (
          <div key={`tgb_suburban-${index + 1}`} className={styles['banner']}>
            <Adfox type="tgb_suburban" onLoad={onLoad} onBannerClick={onBannerClick} minHeight="388px" />
          </div>
        ))}
      </div>
    </Container>
  );
};
